import { Header } from "@/components/layout/Header";
import React from "react";

const Footer = () => (
  <footer className="bg-gray-900 text-white py-12 mt-20">
    <div className="container px-4 mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0">
          <h2 className="text-xl font-bold">Openstudio</h2>
          <p className="text-gray-400 mt-2">Oživte prázdné prostory s Openstudio</p>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          <div>
            <h3 className="text-lg font-medium mb-2">Služby</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">Virtuální zařízení</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Interiérový design</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Realitní služby</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-medium mb-2">Společnost</h3>
            <ul className="space-y-2">
              <li><a href="/kontakt" className="text-gray-400 hover:text-white">Kontakt</a></li>
              <li><a href="/ochrana-osobnich-udaju" className="text-gray-400 hover:text-white">Ochrana osobních údajů</a></li>
              <li><a href="/obchodni-podminky" className="text-gray-400 hover:text-white">Všeobecné obchodní podmínky</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-12 pt-6 text-center">
        <p className="text-gray-400">© {new Date().getFullYear()} Openstudio. Všechna práva vyhrazena.</p>
      </div>
    </div>
  </footer>
);

const OchranaOsobnichUdaju = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1 flex flex-col items-center justify-center py-20">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-bold mb-8">Ochrana osobních údajů</h1>
        <div className="text-lg text-gray-800 space-y-6 whitespace-pre-line">
Ochrana osobních údajů
Tento dokument popisuje způsob, jakým OpenStudio.cz zpracovává a chrání osobní údaje svých uživatelů. Ochrana osobních údajů je pro nás velmi důležitá a dbáme na dodržování všech relevantních zákonů a předpisů týkajících se ochrany osobních údajů, včetně Obecného nařízení o ochraně osobních údajů (GDPR).

Zpracování osobních údajů
OpenStudio.cz zpracovává osobní údaje svých uživatelů za účelem poskytování služeb a optimalizace uživatelského zážitku. Můžeme zpracovávat následující typy osobních údajů:

Jméno a příjmení
E-mailová adresa
Telefonní číslo
Adresa
Informace o platebních metodách
Tyto údaje zpracováváme pouze se souhlasem uživatele nebo pokud je to nezbytné pro plnění smlouvy nebo na základě našeho oprávněného zájmu.

Uchovávání osobních údajů
OpenStudio.cz uchovává osobní údaje svých uživatelů po dobu nezbytnou k dosažení účelu, pro který byly shromážděny, a to v souladu s platnými právními předpisy. Po uplynutí této doby budou osobní údaje buď anonymizovány nebo odstraněny z našich systémů.

Sdílení osobních údajů
OpenStudio.cz neprodává, nepřenechává ani nepůjčuje osobní údaje svých uživatelů třetím stranám bez jejich souhlasu, s výjimkou případů, kdy je to nezbytné k poskytnutí služeb nebo plnění smluvních povinností. Můžeme však sdílet osobní údaje s našimi důvěryhodnými obchodními partnery a poskytovateli služeb za účelem plnění našich služeb.

Práva uživatelů
Uživatelé OpenStudio.cz mají právo:

Získat přístup k informacím o tom, jaké osobní údaje o nich zpracováváme a jak jsou tyto údaje zpracovávány.
Opravit nebo aktualizovat své osobní údaje, pokud jsou nesprávné nebo zastaralé.
Požadovat smazání svých osobních údajů z našich systémů, pokud již nejsou nezbytné pro účely, pro které byly shromážděny.
Podat stížnost u dozorového úřadu, pokud se domnívají, že zpracování jejich osobních údajů porušuje platné zákony o ochraně osobních údajů.

Kontaktní informace
Pokud máte jakékoli otázky nebo požadavky týkající se ochrany osobních údajů, neváhejte nás kontaktovat:

E-mail: info@openstudio.cz

Adresa: OpenStudio.cz, Hlavní 123, 100 00 Praha

Tento dokument o ochraně osobních údajů byl naposledy aktualizován dne 18. března 2024.

Tento dokument by měl být přizpůsoben konkrétním potřebám a postupům vašeho webu a měl by být upraven v souladu s platnými zákony a předpisy v oblasti ochrany osobních údajů.
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default OchranaOsobnichUdaju; 